import React from "react";
import classNames from "classnames";
import "./SoundSwitcher.scss";

const SoundSwitcher = (props) => {
  let soundClassName = classNames({
    "switch-sound": true,
  });

  let sliderClassName = classNames({
    "slider-sound": true,
    round: true,
  });

  return (
    <label id="switch-sound" className={soundClassName}>
      <input
        type="checkbox"
        checked={props.checked}
        onChange={props.onChange}
        id="slider-sound"
      ></input>
      <span className={sliderClassName}></span>
    </label>
  );
};

export default SoundSwitcher;
